export default {
  location: {
    confirm: '确定',
    availableWithDot: ' 可用 · ',
    destinationCharging: '目的地充电',
    hasHomeCharger: '有家充桩安装记录',
    nearby: '附近的',
    nearbyHomeChargers: '附近的家充桩安装记录',
    noHomeCharger: '暂无家充桩安装记录',
    numberOfChargers: '个充电桩',
    numberOfSuperChargers: '个超级充电桩',
    requestPreCheck: '申请免费勘测服务',
    searchLocation: '查找充电信息',
    searchLocationPlaceholder: '输入地点',
    searchChargers: '查找充电桩',
    superCharging: '超级充电',
    teslaSuperCharger: '特斯拉超级充电',
    teslaDestinationCharger: '特斯拉目的地充电',
    typeCityAndDistrictInfo: '输入城市和小区名称',
    otherCharger: '第三方充电站',
    otherChargerQuery: '充电站',
    otherChargerTag: '充电站',
    filterBrand: '特斯拉充电站',
    locate: '定位',
    list: '列表',
    map: '地图',
    openToNonTesla: '向新能源车辆开放',
    availableCount: '可用充电桩',
    currentRate: '当前电价',
    rateUnit: '度',
    hasHomeChargerInstalled: '此区域已有特斯拉家庭充电桩安装',
    noHomeChargerInstalled: '此区域暂无特斯拉家庭充电桩安装',
    homeChargerInfoDisclaimer: '此处充电桩安装信息仅供参考，是否具备安装条件仍需与场地方确认。',
  },
};
